export const InvoicingRoute = {
  path: '/accounting/invoicing',
  load: () => import('./AccountInvoicing'),
};

export const InvoicingDetailsRoute = {
  path: '/accounting/invoicing/:id',
  load: () => import('./AccountInvoicing'),
};
